var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.78941 3.73688H13.1578V1.84214H1.78941V3.73688ZM13.1167 4.68425L12.326 13.3821C12.2373 14.358 11.419 15.1053 10.4391 15.1053H4.50819C3.52822 15.1053 2.70995 14.358 2.62123 13.3821L1.83052 4.68425H1.78941C1.26619 4.68425 0.842041 4.2601 0.842041 3.73688V1.84214C0.842041 1.31893 1.26619 0.894775 1.78941 0.894775H13.1578C13.681 0.894775 14.1052 1.31893 14.1052 1.84214V3.73688C14.1052 4.2601 13.681 4.68425 13.1578 4.68425H13.1167ZM2.78179 4.68425L3.56471 13.2963C3.60907 13.7843 4.01821 14.1579 4.50819 14.1579H10.4391C10.929 14.1579 11.3382 13.7843 11.3825 13.2963L12.1654 4.68425H2.78179ZM6.05257 8.00004C6.05257 7.73843 6.26464 7.52635 6.52625 7.52635C6.78786 7.52635 6.99994 7.73843 6.99994 8.00004V10.8421C6.99994 11.1038 6.78786 11.3158 6.52625 11.3158C6.26464 11.3158 6.05257 11.1038 6.05257 10.8421V8.00004ZM7.94731 8.00004C7.94731 7.73843 8.15938 7.52635 8.42099 7.52635C8.6826 7.52635 8.89467 7.73843 8.89467 8.00004V10.8421C8.89467 11.1038 8.6826 11.3158 8.42099 11.3158C8.15938 11.3158 7.94731 11.1038 7.94731 10.8421V8.00004Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash2);
export default __webpack_public_path__ + "static/media/trash2.d426c1b6205ca8fd77c93efdb69dfd0e.svg";
export { ForwardRef as ReactComponent };